import { render, staticRenderFns } from "./UpdateUserFeature.vue?vue&type=template&id=17f84c9d&"
import script from "./UpdateUserFeature.vue?vue&type=script&lang=js&"
export * from "./UpdateUserFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports